module.exports = __webpack_public_path__ + "static/media/img003.ef649511.jpg";